var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "course-contents", class: { mobile: _vm.useMobileStyles } },
    [
      _c("div", { staticClass: "container" }, [
        _c("h3", [_vm._v("Engaging, interactive learning")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "course-content" },
          [
            _c("ResponsiveImage", {
              staticClass: "sample-ui",
              attrs: {
                src: _vm.useMobileStyles
                  ? [
                      "/site_media/version-55f8f7cd28/images/bfe/classroom-course-content-mobile.png"
                    ]
                  : [
                      "/site_media/version-bb82253e69/images/bfe/classroom-course-content.png",
                      "/site_media/version-5237d4a73c/images/bfe/classroom-course-content-2x.png"
                    ],
                alt: "Demo"
              }
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1)
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sections" }, [
      _c("div", { staticClass: "section heart corner-top corner-left" }, [
        _c("span", { staticClass: "icon" }, [
          _c("span", { staticClass: "b-sprite-bfe-love-pencil" })
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Learn deeply")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            From algebra to quantum physics, enjoy fun, guided explorations in thousands of\n            interesting topics.\n          "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section problem corner-top corner-right" }, [
        _c("span", { staticClass: "icon" }, [
          _c("span", { staticClass: "b-sprite-bfe-problem-solving" })
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Problem solving")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Improve critical thinking skills with mind-bending problems and puzzles."
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section interactive corner-bottom corner-left" },
        [
          _c("span", { staticClass: "icon" }, [
            _c("span", { staticClass: "b-sprite-bfe-interactive-lessons" })
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Interactive lessons")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Drag objects and manipulate variables to get to aha moments fast."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section explanations corner-bottom corner-right" },
        [
          _c("span", { staticClass: "icon" }, [
            _c("span", { staticClass: "b-sprite-bfe-indepth-explantion" })
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("In-depth explanations")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            Master concepts with step-by-step explanations of key ideas and problem solving\n            techniques.\n          "
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mini-footer" }, [
      _c(
        "a",
        { staticClass: "principles-btn", attrs: { href: "/principles" } },
        [_vm._v("Visit our Principles of Learning")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }